import ReactQuill from "react-quill";
import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import "react-quill/dist/quill.snow.css";

const RichTextEditor = ({
  name,
  value,
  onChange,
  error,
  readOnly,
  toolbar,
  height,
  width,
  borderRadius,
  onlyText = false,
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleEditorFocus = () => {
    setIsFocused(true);
  };

  const handleEditorBlur = () => {
    setIsFocused(false);
  };

  const toolbarOptions = [
    [{ header: "1" }, { header: "2" }],
    [{ size: ["small", false, "large", "huge"] }],
    [{ list: "ordered" }, { list: "bullet" }],
    ["bold", "italic", "underline"],
  ];

  const handleChange = useCallback(
    (content, delta, source, editor) => {
      const valueToSend = onlyText ? editor.getText().trim() : content;
      if (typeof onChange === "function" && name) {
        onChange({
          target: {
            name,
            value: valueToSend,
          },
        });
      }
    },
    [onlyText, onChange, name]
  );

  return (
    <div style={{ width: width || "100%" }}>
      <ReactQuill
        value={value}
        readOnly={readOnly}
        onChange={handleChange}
        onFocus={handleEditorFocus}
        onBlur={handleEditorBlur}
        modules={{
          toolbar: toolbar ? toolbarOptions : null,
        }}
        formats={["header", "size", "list", "bold", "italic", "underline"]}
        style={{
          border: error
            ? "2px solid red"
            : isFocused
            ? "2px solid #17c1e8"
            : "2px solid #d2d6da",
          width: width || "100%",
          borderRadius: borderRadius || "",
        }}
        className="custom-quill"
      />

      <style jsx>{`
        .custom-quill .ql-container {
          min-height: ${typeof height === "number" ? `${height}px` : height || "100%"};
        }
        .custom-quill .ql-editor {
          min-height: ${typeof height === "number" ? `${height}px` : height || "100%"};
        }
      `}</style>
    </div>
  );
};

RichTextEditor.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  toolbar: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool,
  error: PropTypes.bool,
  onlyText: PropTypes.bool,
  name: PropTypes.string.isRequired,
};

export default RichTextEditor;
